
export function setTabChangeHandlers(rootNode) {
    let root = rootNode instanceof HTMLElement ? rootNode : document;
    //update tabs elements on changing
    root.querySelectorAll(".tabs input[type=radio]").forEach(function (el) {
        el.addEventListener("change", function (e) {
            let id = e.target.id;
            let items = e.target.parentNode.querySelectorAll(":scope > ul > li label");
            let width = Math.floor(100 / items.length);
            items.forEach( function (el) {
                if ((el.getAttribute("for") == id) && e.target.checked) {
                    el.classList.add("selectedItem");
                } else {
                    el.classList.remove("selectedItem");
                }
                el.parentNode.style.width = width + "%";
            });
            e.target.parentNode.querySelectorAll(":scope > .tab-content section").forEach( function (el) {
                if ((el.getAttribute("for") == id) && e.target.checked) {
                    el.classList.add("selectedItem");
                } else {
                    el.classList.remove("selectedItem");
                }
            });

        });
        if (el.checked)
            el.dispatchEvent(new Event("change"));
    });
}
